<template>
    <div id="unlockProModal" class="modal fade" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <unlock-starter-features v-if="content_type === 'starter'"></unlock-starter-features>
              <unlock-pro-features v-if="content_type === 'pro'"></unlock-pro-features>
              <unlock-ultimate-features v-if="content_type === 'ultimate'"></unlock-ultimate-features>

                <div class="modal-footer">
                    <button class="btn close-btn" @click.prevent="close">
                        <i class="fa fa-times mr-1"></i><strong>{{ 'Cancel' | trans }}</strong>
                    </button>
                    <button class="btn premium-btn" @click.prevent="openPremiumModal">
                        <i class="fa fa-chevron-right"></i><strong>{{ 'Get Premium' | trans }}</strong>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import { registerPaymentModalHelper } from '../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';
import { EventBus } from '../../events/event.bus';
import { EVENT_PAYMENT_UNLOCK_PRO, EVENT_PAYMENT_UNLOCK_STARTER, EVENT_PAYMENT_UNLOCK_ULTIMATE } from '../../events/payment.events';
import UnlockProFeatures from './Content/UnlockProFeatures.vue';
import PaymentManager from "../../manager/PaymentManager";
import user from "../../mixins/user.mixin";
import UnlockStarterFeatures from "./Content/UnlockStarterFeatures.vue";
import UnlockUltimateFeatures from "./Content/UnlockUltimateFeatures.vue";

export default {
    name: 'UnlockProModal',
    props: {},
    components: {UnlockUltimateFeatures, UnlockStarterFeatures, UnlockProFeatures },
    mixins: [store, user],
    data() {
        return {
          content_type: 'none'
        };
    },
    mounted: function () {
        $('#unlockProModal').modal({ show: false });
    },
    created: function () {
      EventBus.$on(EVENT_PAYMENT_UNLOCK_STARTER, (data) => {
        if (this.isFreeUser) {
          this.content_type = 'starter';
          $('#unlockProModal').modal('show');
        }
      });
      EventBus.$on(EVENT_PAYMENT_UNLOCK_PRO, (data) => {
        if (this.isFreeUser || this.isStarterUser) {
          this.content_type = 'pro';
          $('#unlockProModal').modal('show');
        }
      });
      EventBus.$on(EVENT_PAYMENT_UNLOCK_ULTIMATE, (data) => {
        if (this.isFreeUser || this.isStarterUser || this.isProUser) {
          this.content_type = 'ultimate';
          $('#unlockProModal').modal('show');
        }
      });
    },
    methods: {
        close() {
            $('#unlockProModal').modal('hide');
        },
        openPremiumModal() {
            this.close();
            PaymentManager.buyProAndUltimate();
        },
    },
    computed: {},
};
</script>
<style lang="scss">
#unlockProModal {
    img {
        width: 100%;
      height: auto;
    }

    .modal-dialog {
        width: 599px;
        max-width: 95%;
        border-radius: 9px;
        overflow: hidden;
    }

    .close-btn {
        background: #d9d9d9;
        height: 38px;
        gap: 10px;
        padding: 0 10px 0 10px;
        font-weight: 600;
    }

    .premium-btn {
        background-color: #ffaa00;
        height: 38px;
        gap: 10px;
        display: flex;
        align-items: center;
        font-weight: 600;
        padding: 0 10px 0 10px;
    }

    .modal-content-title {
        font-size: 28px;
        font-weight: 600;
    }

    .modal-content {
        h2 {
            margin-top: 0;
        }

        font-size: 17.5px;
        border: 1px solid #ccc;

        p {
            font-size: 17.5px;
        }
    }

    .modal-body {
        padding: 20px;
    }

    .modal-footer {
        display: flex;
        padding: 10px 10px;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        background: #f8f9fa;

        .btn {
            margin: 0;
        }
    }
}
</style>
